import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "preloader-area",
  id: "preloader"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"loader\"><div class=\"\"><span>T</span><span>H</span><span>E</span><span>T</span><span>I</span><span>N</span><span>Y</span><span>L</span><span>E</span><span>A</span><span>V</span><span>E</span><span>S</span></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}